import React, { useEffect } from "react"
import { NumberFieldSeeker } from "@ui-seeker/core"
import { dsRepricingDrawerData, dsRepricingDrawerErrors } from "Pages/DsRepricing/Page/@signals"

// The server's default too (`repricing_strategy.priority`), and what the
// legacy backend already used. Lower wins on an overlap.
export const DEFAULT_PRIORITY = 50

const isValid = v => Number.isInteger(Number(v)) && Number(v) >= 1 && Number(v) <= 99

// Rules are allowed to cover the same scope as long as their priority differs — without a hierarchy
// two rules pricing the same vehicle on the same date have no way to be resolved. Only a tie is
// refused when saving. The details live in the tooltip so the input row stays clean.
export default function DsRepricingPriority() {
	const value = dsRepricingDrawerData.value.priority ?? DEFAULT_PRIORITY

	useEffect(() => {
		dsRepricingDrawerErrors.value = { ...dsRepricingDrawerErrors.value, priority: isValid(value) }
	}, [value])

	const handleChange = e => {
		const raw = e.target.value
		dsRepricingDrawerData.value = {
			...dsRepricingDrawerData.value,
			priority: raw !== '' ? Number(raw) : null,
		}
	}

	return (
		<NumberFieldSeeker
			label="Priority"
			placeholder={String(DEFAULT_PRIORITY)}
			value={value ?? ''}
			onChange={handleChange}
			error={!isValid(value) ? "1–99" : undefined}
			title="Lower is higher — when two rules overlap, the lower priority wins. Two rules with the same priority and same scope cannot be saved. It also decides between brokers: when two strategies write the same tariff, each bracket goes to the one with the lower number; on a tie, to the decision that moves the price more."
		/>
	)
}
